import type { FC } from 'react';
import litter from './assets/litter.png';
import parent from './assets/parent.png';
import paws from './assets/paws.png';
import process from './assets/process.png';
import puppyLove from './assets/puppy-love.png';
import refund from './assets/puppy-refund.png';
import puppy from './assets/puppy.png';
import type { IllustrationProps } from './types';

export const Illustration: FC<IllustrationProps> = ({ type, size = 96 }) => {
  switch (type) {
    case 'puppy':
      return <img src={puppy} alt="illustration" width={size} />;
    case 'paws':
      return <img src={paws} alt="illustration" width={size} />;
    case 'litter':
      return <img src={litter} alt="illustration" width={size} />;
    case 'parent':
      return <img src={parent} alt="illustration" width={size} />;
    case 'puppy-love':
      return <img src={puppyLove} alt="illustration" width={size} />;
    case 'refund':
      return <img src={refund} alt="illustration" width={size} />;
    case 'process':
      return <img src={process} alt="illustration" width={size} />;
    default:
      return null;
  }
};
